var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.967773,
    y: 0.0185547,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1B1F23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9557 5.52295C9.22883 5.52295 6.21021 8.52957 6.21021 12.2416C6.21021 15.2147 8.14111 17.7258 10.8225 18.616C11.1597 18.6748 11.2862 18.4732 11.2862 18.2969C11.2862 18.1373 11.2778 17.6082 11.2778 17.0455C9.58297 17.3563 9.14451 16.634 9.0096 16.2561C8.93371 16.0629 8.60487 15.4666 8.31818 15.3071C8.08209 15.1811 7.74481 14.8703 8.30975 14.8619C8.84096 14.8535 9.2204 15.349 9.34688 15.5506C9.95397 16.5668 10.9236 16.2813 11.3115 16.1049C11.3705 15.6682 11.5476 15.3742 11.7415 15.2063C10.2407 15.0383 8.67232 14.4588 8.67232 11.8889C8.67232 11.1583 8.93371 10.5536 9.36374 10.0833C9.29628 9.9153 9.06019 9.22663 9.43119 8.30281C9.43119 8.30281 9.99613 8.12645 11.2862 8.99148C11.8259 8.84031 12.3992 8.76472 12.9726 8.76472C13.546 8.76472 14.1193 8.84031 14.659 8.99148C15.9491 8.11805 16.514 8.30281 16.514 8.30281C16.885 9.22663 16.6489 9.9153 16.5815 10.0833C17.0115 10.5536 17.2729 11.1499 17.2729 11.8889C17.2729 14.4672 15.6961 15.0383 14.1952 15.2063C14.4397 15.4162 14.6505 15.8194 14.6505 16.4492C14.6505 17.3479 14.6421 18.0701 14.6421 18.2969C14.6421 18.4732 14.7686 18.6832 15.1059 18.616C17.7704 17.7258 19.7013 15.2063 19.7013 12.2416C19.7013 8.52957 16.6826 5.52295 12.9557 5.52295Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.e64039518248cbe1e9321e15080b38cd.svg";
export { ForwardRef as ReactComponent };